module.exports = __webpack_public_path__ + "static/media/qrcode.54881623.webp";